<template>
  <div class="final-gradient-parameters">
    <s-empty-list
      v-if="!tabInfo.windingAmount"
      class="final-gradient-parameters__empty-list"
    />
    <view-edit-panel
      v-else
      class="final-gradient-parameters-data px-0"
      permission-to-edit="PER013"
      hide-edit-when-without-permission
      :value="parameters"
      :disable-save="isFormInvalid"
      :loading="loading"
      @changing="save"
    >
      <div
        slot-scope="data"
        class="col-12"
      >
        <parameters-form
          :parameters="data.item"
          :edit-mode="data.editing"
          :is-loading="loading"
          :is-saving="saving"
          :key="formKey"
          @force-rerender-form="forceRerenderForm"
          @invalid-form="invalidFormHandler"
        />
      </div>
    </view-edit-panel>
  </div>
</template>

<script>
import eventBus from '@/services/globalEventBus';
import engineeringEvents from '@/domain/events/engineering';
import Service
 from '@/domain/services/installation/engineering/finalGradient/finalGradientService';
import ViewEditPanel from '@/components/ViewEditPanel';
import ParametersForm
  from '@/domain/components/installation/engineering/finalGradient/ParametersForm';

export default {
  name: 'FinalGradientParametersTab',
  props: {
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ViewEditPanel,
    ParametersForm,
  },
  data: () => ({
    parameters: {},
    loading: false,
    saving: false,
    isFormInvalid: false,
    formKey: 0,
  }),
  computed: {
    assetModuleId() {
      const { assetModuleId } = this.$route.params;
      return assetModuleId;
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.deinit();
  },
  methods: {
    init() {
      eventBus.on(engineeringEvents.refreshDataTab, this.refreshData, this);
      this.refreshData(true);
    },
    deinit() {
      eventBus.off(engineeringEvents.refreshDataTab, this.refreshData, this);
    },
    refreshData(showLoading = false) {
      if (!this.tabInfo.windingAmount) return;
      this.getParameters(showLoading);
    },
    getParameters(showLoading = false) {
      this.loading = showLoading;

      return Service.getParameters(this.assetModuleId)
        .then((response) => {
          this.parameters = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save({ newValue, accept, reject }) {
      this.saving = true;

      const { alarmTemperatureReachTime, shutdownTemperatureReachTime } = newValue;
      const payload = {
        alarmTemperatureReachTime,
        shutdownTemperatureReachTime,
      };

      return Service.putParameters(this.assetModuleId, payload)
        .then((response) => {
          accept(response);
          this.refreshData(true);
          this.forceRerenderForm();
        })
        .catch(reject)
        .finally(() => {
          this.saving = false;
        });
    },
    invalidFormHandler(value) {
      this.isFormInvalid = value;
    },
    forceRerenderForm() {
      this.formKey += 1;
    },
  },
};
</script>

<style lang="sass" scoped>
.final-gradient-parameters
  &__empty-list
    display: flex
    flex-direction: column
    justify-content: center
    height: 415px
</style>
